<template>
	
	<div class="voucher-list" @click="event => {event.stopPropagation()}">
		<transition>
			<div v-if="vouchers">
				<div v-if="!merchantId" class="voucher-list">
					<div v-for="v in vouchers" :key="v.id">
						<a @click="handleGroupClick(v)">
							<v-row class="voucherRow">
								<v-col class="v-col-3 icon-col" style="">
									<img v-if="v.cardUrl" :src="v.cardUrl" :class="'icon ' + (showSaving ? 'mt-3' : 'mt-2')">
								</v-col>
								<v-col class="v-col-4 details-col">
									<span class="bold">{{v.merchantName}}</span><br/>
								</v-col>
								<v-col class="v-col-5 amount-col">
									<span class="totalVouchers">
										{{ v.totalVouchers }} {{ v.totalVouchers > 1 ? label + 's' : label }} <img class="arrow" src="../../assets/arrow-right.png">
									</span>
								</v-col>
							</v-row>
							<v-divider class="mt-2 mb-6"></v-divider>
						</a>
					</div>
				</div>
				<div v-else>
					<div style="display: flex; justify-content: space-between; align-items: center;">
						Archived
						<div style="display: flex; align-items: center;">
							<span>Sort by: </span>
							<v-menu>
								<template v-slot:activator="{ props }">
									<div v-bind="props" class="mg-circle-icon-button">
										<span>{{ sortOption === 'recentlyUsed' ? 'Recently used' : 'Recently purchased' }}</span>
									</div>
								</template>
								<v-list>
									<v-list-item @click="sortOption = 'recentlyUsed'; sortVouchers()">
										<v-icon icon="mdi-clock-outline" /> Recently used
									</v-list-item>
									<v-list-item @click="sortOption = 'recentlyPurchased'; sortVouchers()">
										<v-icon icon="mdi-cart-outline" /> Recently purchased
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
					</div>
					<v-divider class="mt-2 mb-6"></v-divider>
					<div v-for="voucher in vouchers.vouchers" :key="voucher.id">
						<a @click="handleVoucherClick(voucher)">
							<v-row class="voucherRow">
								<v-col class="v-col-3 icon-col">
									<img :src="voucher.discount.cardUrl" class="icon">
								</v-col>
								<v-col class="v-col-6 details-col">
									<span class="bold">{{ voucher.discount.merchant?.name || 'Unknown Merchant' }}</span><br/>
									<span v-if="voucher.expiryDateTime < new Date()" class="expired">Expired: {{ _formattedTransactionDate(voucher.expiryDateTime) }}</span>
									<span v-else class="expires">Expires: {{ _formattedTransactionDate(voucher.expiryDateTime) }}</span>
								</v-col>
								<v-col class="v-col-2 amount-col">
									<span class="totalVouchers">
										{{ formatter.format(voucher.faceValue) }}
									</span>
								</v-col>
							</v-row>
						</a>
						<v-divider class="mt-2 mb-6"></v-divider>
					</div>
				</div>
			</div>
		</transition>
	</div>
	
</template>

<script>
import Helpers from '../../mixins/Helpers';

export default {
	
	name: "VoucherList",
	mixins: [Helpers],
	props: {
		search: {default: false},
		preSearch: {default: null},
		categories: {default: null},
		vouchers: {default: () => []},
		groupedVouchers: {default: () => []},
		formatter: {default: null},
		today: {default: null},
		yesterday: {default: null},
		showSaving: {default: false},
		spendLabel: {default: null},
		label: {default: "voucher"},
		showFavourites: {default: false},
		merchantId: {default: null}
	},
	data() {
		return{
			query: this.preSearch ?? null,
			context: false,
			selectedGroupVouchers: [],
			sortOption: 'recentlyUsed',
		}
	},
	methods: {
		onLoad() {
			this.sortVouchers();
		},
		onClear() {
			this.$refs.search.blur();
		},
		toggleFavourite: function(v) {
			this.$emit('favouriteToggled', v);
		},
		handleGroupClick(v) {
			console.log('handleGroupClick:', v);
			this.$emit('group-clicked', v);
			console.log('this.vouchers:', this.vouchers);
		},
		handleVoucherClick(voucher) {
			this.$emit('voucher-clicked', voucher);
		},
		exitGroupView() {
			this.$emit('exit-group-view');
		},
		sortVouchers() {
			if (this.sortOption === 'recentlyUsed') {
				this.selectedGroupVouchers.sort((a, b) => {
					const aLatestTransaction = Math.max(...a.customerVoucherTransactions.map(t => new Date(t.createdDateTime)));
					const bLatestTransaction = Math.max(...b.customerVoucherTransactions.map(t => new Date(t.createdDateTime)));
					return bLatestTransaction - aLatestTransaction;
				});
			} else if (this.sortOption === 'recentlyPurchased') {
				this.selectedGroupVouchers.sort((a, b) => new Date(b.createdDateTime) - new Date(a.createdDateTime));
			}
		},
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.v-chip {
	margin-right: 5px;
	width: 25px;
	text-align: center;
	.v-icon{
		margin-left: -3px;
		text-align: center;
	}
}

.icon {
	width: 48px;
	height: 32px;
	background-color: #E7ECF7;
	border-radius: 6px;
}

.amount-col {
	text-align: right !important;
	align-content: center;
	display: flex; 
	justify-content: flex-end;
	padding-right: 0; 
}

.details-col {
	align-content: center;
	text-overflow: ellipsis;
	font-size: 14px;
}

.icon-col {
	vertical-align: middle;
}

.description {
	font-size: 12px;
	color: #555555;
	font-weight: lighter;
	display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.totalVouchers {
	font-size: 14px;
	font-weight: bold;
	align-content: center;
}

/* Come back to this */
.search-col .v-text-field .v-field__clearable {
	display: block !important;
}

.savingRow {
	.v-col {
		padding-top: 0px;
	}
	
}

.arrow {
	width: 16px !important;
	height: 10px !important;
}

.expired {
	background: #F4DCDC;
	font-size: 11px;
}
.expires {
	font-size: 11px;
}

.backButton {
	justify-content: flex-start !important;
}

.voucherRow {
	margin-top: -25px;
	margin-bottom: -10px;
}

.mg-circle-icon-button {
    background-color: #ffffff77;
    border-radius: 50% !important;
    height: auto;
    width: auto;
    padding: 5px 10px;
	padding-top: 10px;
    text-align: center;
    margin-top: -5px;
    font-size: 12px; /* Reduced font size */
    text-decoration: underline; /* Added underline */
    cursor: pointer;
}

.voucher-list label {
    position: relative;
    top: 2px; /* Adjusted to bring the label down slightly */
}
</style>